import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { Form, Button } from 'components/common';
import { withTranslation } from 'language/i18n';
import { forgotPassword } from 'models/user';
import { StatusContext } from 'contexts/statusContext';

const EmailVerification = ({ t, email }) => {
  const router = useRouter();

  const { setErrorState } = useContext(StatusContext);

  const [onResponse, setOnResponse] = useState(false);

  const sendResetMail = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        await forgotPassword(email);
        router.push({
          pathname: '/forgot-password/email-verification',
        });
      } catch (error) {
        console.log('sendResetMailErr', error);
        if (error.status) {
          setErrorState({
            title: t('alert'),
            text: error.message,
            buttonText: t('close'),
            onClickButton: () => setErrorState({}),
          });
        }
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <div className="col-md-10 col-lg-8 offset-lg-1 mt-5 mt-md-0">
      <Form layout="vertical" onFinish={sendResetMail}>
        <div className="mb-5">
          <div className="sign sign--success">
            <i className="fa-solid fa-check" />
          </div>
        </div>
        <div className="fs-22 fw-900 mb-3">{t('sentResetLink')}</div>
        <div className="mb-5">
          Şifre sıfırlama linki mail adresinize iletildi. Mail adresinize gelen linke tıklayarak şifrenizi sıfırlayabilirsiniz.
        </div>
        <Button
          loading={onResponse}
          htmlType="submit"
          className="im-button im-button--outline-yellow2 im-button--fluid im-button--center mt-5 mb-5"
          label={t('didntReceiveResetCode')}
        />
      </Form>
    </div>
  );
};

EmailVerification.propTypes = {
  t: PropTypes.func,
  email: PropTypes.string,
};

export default withTranslation('common')(EmailVerification);
